import React, { useState, useContext, useEffect } from "react";
import { DialogContent, TextField, Box, Button, DialogActions, IconButton, Grid, InputAdornment } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import { RootStoreContext } from '../../app/store/root'
import { EnumConfiguracion } from "../../shared/Enumerables";
import { ErrorMessages } from "../../app/util/messages";
import { validateContieneMayusuculas, validateContieneNumeros, validateContieneCaracteresEspeciales } from "../../app/util/util";
import { observer } from "mobx-react-lite";
import Visibility from '@mui/icons-material/Visibility';
import VisibilityOff from '@mui/icons-material/VisibilityOff';


const ModalChangePass = ({ onClose }) => {

    const rootStore = useContext(RootStoreContext);

    const {
        updatePasswordUser: _updatePasswordUser
    } = rootStore.usuarioStore;

    const {
        consultarParametro
    } = rootStore.configuracionStore

    const initialState = {
        AnteriorPass: undefined,
        NuevoPass: undefined,
        ConfirmarPass: undefined
    };

    const [model, setModel] = useState(initialState);
    const [errors, setErrors] = useState({
        AnteriorPass: null,
        NuevoPass: null,
        ConfirmarPass: null
    });

    const [messages, setMessages] = useState({
        AnteriorPass: '',
        NuevoPass: '',
        ConfirmarPass: ''
    });

    const [contraseniaLongitudMinima, setContraseniaLongitudMinima] = useState(null)
    const [contraseniaLongitudMaxima, setContraseniaLongitudMaxima] = React.useState(null)
    const [contraseniaRequiereMayusculas, setContraseniaRequiereMayusculas] = React.useState(null)
    const [contraseniaRequiereNumeros, setContraseniaRequiereNumeros] = React.useState(null)
    const [contraseniaRequiereCaracteresEspeciales, setContraseniaRequiereCaracteresEspeciales] = React.useState(null)
    const [disabledAceptar, setDisabledAceptar] = React.useState(true)

    useEffect(() => {
        cargarConfiguracionContrasenia()
        setModel(initialState)
    }, []);

    useEffect(() => {
        if (errors.AnteriorPass == false && errors.NuevoPass == false && errors.ConfirmarPass == false) {
            setDisabledAceptar(false)
        } else {
            setDisabledAceptar(true)
        }
    }, [errors]);

    useEffect(() => {
        if (contraseniaLongitudMinima && contraseniaLongitudMaxima) {
            ErrorMessages.usuario.ContraseñaLongitud = ErrorMessages.usuario.ContraseñaLongitud.replace('{0}', contraseniaLongitudMinima.valor)
            ErrorMessages.usuario.ContraseñaLongitud = ErrorMessages.usuario.ContraseñaLongitud.replace('{1}', contraseniaLongitudMaxima.valor)
        }
    }, [contraseniaLongitudMinima, contraseniaLongitudMaxima])

    const cargarConfiguracionContrasenia = async () => {
        setContraseniaLongitudMinima(await consultarParametro(EnumConfiguracion.Contrasenia_Longitud_Minima))
        setContraseniaLongitudMaxima(await consultarParametro(EnumConfiguracion.Contrasenia_Longitud_Maxima))
        setContraseniaRequiereMayusculas(await consultarParametro(EnumConfiguracion.Contrasenia_Requiere_Mayusculas))
        setContraseniaRequiereNumeros(await consultarParametro(EnumConfiguracion.Contrasenia_Requiere_Numeros))
        setContraseniaRequiereCaracteresEspeciales(await consultarParametro(EnumConfiguracion.Contrasenia_Requiere_Caracteres_Especiales))
    }

    /* Methods */
    const setValue = (key, value) => {
        setModel({ ...model, ...{ [key]: value } });
    };
    const setError = (key, value) => {
        setErrors({ ...errors, ...{ [key]: value } });
    };
    const setMessage = (key, value) => {
        setMessages({ ...messages, ...{ [key]: value } });
    };

    const updatePasswordUser = async () => {
        rootStore.logisticBackdropStore.openLoading()
        if (validarUsuario()) {
            let resp = await _updatePasswordUser(model)
            rootStore.logisticBackdropStore.closeLoading()
            if (!resp.data.exito) {
                if (resp.data.validations.length > 0) {
                    const Errors = {
                        AnteriorPass: false,
                        NuevoPass: false,
                        ConfirmarPass: false
                    }
                    const Mensajes = {
                        AnteriorPass: '',
                        NuevoPass: '',
                        ConfirmarPass: ''
                    }
                    resp.data.validations.forEach(element => {
                        if (element.campo.toUpperCase() == 'AnteriorPass'.toUpperCase()) {
                            Errors.AnteriorPass = true
                            Mensajes.AnteriorPass = element.mensaje
                        }
                        if (element.campo.toUpperCase() == 'ConfirmarPass'.toUpperCase()) {
                            Errors.ConfirmarPass = true
                            Mensajes.ConfirmarPass = element.mensaje
                        }
                    });
                    setErrors({ ...Errors })
                    setMessages({ ...Mensajes })
                }
            } else {
                rootStore.alertStore.alertUpdateSuccess('Contraseña actualizada exitosamente');
                onClose()
            }
        } else {
            rootStore.logisticBackdropStore.closeLoading()
        }
    }

    const validarUsuario = () => {
        const Errors = {
            AnteriorPass: false,
            NuevoPass: false,
            ConfirmarPass: false
        }
        const Mensajes = {
            AnteriorPass: '',
            NuevoPass: '',
            ConfirmarPass: ''
        }
        //Validar contraseña vs configuracion
        if ((model.AnteriorPass?.length ?? 0) < 1) {
            Errors.AnteriorPass = true
            Mensajes.AnteriorPass = ErrorMessages.usuario.ContraseñaRequerida
        }
        if ((model.NuevoPass?.length ?? 0) < parseInt(contraseniaLongitudMinima.valor) || (model.NuevoPass?.length ?? 0) > parseInt(contraseniaLongitudMaxima.valor)) {
            Errors.NuevoPass = true
            Mensajes.NuevoPass = ErrorMessages.usuario.ContraseñaLongitud
        }
        if (contraseniaRequiereMayusculas?.valor == 'True' && !validateContieneMayusuculas(model.NuevoPass) && !Errors.NuevoPass) {
            Errors.NuevoPass = true
            Mensajes.NuevoPass = ErrorMessages.usuario.ContraseñaMayuscula
        }
        if (contraseniaRequiereNumeros?.valor == 'True' && !validateContieneNumeros(model.NuevoPass) && !Errors.NuevoPass) {
            Errors.NuevoPass = true
            Mensajes.NuevoPass = ErrorMessages.usuario.ContraseñaNumero
        }
        if (contraseniaRequiereCaracteresEspeciales?.valor == 'True' && !validateContieneCaracteresEspeciales(model.NuevoPass) && !Errors.NuevoPass) {
            Errors.NuevoPass = true
            Mensajes.NuevoPass = ErrorMessages.usuario.ContraseñaCaracter
        }
        if (model.NuevoPass != model.ConfirmarPass) {
            Errors.ConfirmarPass = true
            Mensajes.ConfirmarPass = ErrorMessages.usuario.ContraseñasDiferentes
        }
        if (model.AnteriorPass == model.NuevoPass) {
            rootStore.alertStore.alertError(ErrorMessages.usuario.ContraseñasIguales)
            return
        }

        setErrors({ ...Errors })
        setMessages({ ...Mensajes })
        if (Errors.AnteriorPass || Errors.NuevoPass || Errors.ConfirmarPass)
            return false
        return true
    }

    const validarNuevoPass = (value) => {
        if (value.length < parseInt(contraseniaLongitudMinima?.valor ?? 6) || value.length > parseInt(contraseniaLongitudMaxima?.valor ?? 12)) {
            setError("NuevoPass", true)
            setMessage("NuevoPass", ErrorMessages.usuario.ContraseñaLongitud)
            return
        }

        if (model.ConfirmarPass?.length > 0 && value != model.ConfirmarPass) {
            setError("NuevoPass", true)
            setMessage("NuevoPass", ErrorMessages.usuario.ContraseñasDiferentes)
            return
        }
        if (model.ConfirmarPass?.length > 0 && value == model.ConfirmarPass) {
            setErrors({
                AnteriorPass: errors.AnteriorPass,
                NuevoPass: false,
                ConfirmarPass: false
            })
            setMessages({
                AnteriorPass: messages.AnteriorPass,
                NuevoPass: '',
                ConfirmarPass: ''
            })
            return
        }
        setError("NuevoPass", false)
        setMessage("NuevoPass", '')
    }

    const validarConfirmarPass = (value) => {
        if (value.length < parseInt(contraseniaLongitudMinima?.valor ?? 6) || value.length > parseInt(contraseniaLongitudMaxima?.valor ?? 12)) {
            setError("ConfirmarPass", true)
            setMessage("ConfirmarPass", ErrorMessages.usuario.ContraseñaLongitud)
            return
        }

        if (model.NuevoPass?.length > 0 && value != model.NuevoPass) {
            setError("ConfirmarPass", true)
            setMessage("ConfirmarPass", ErrorMessages.usuario.ContraseñasDiferentes)
            return
        }

        if (model.NuevoPass?.length > 0 && value == model.NuevoPass) {
            setErrors({
                AnteriorPass: errors.AnteriorPass,
                NuevoPass: false,
                ConfirmarPass: false
            })
            setMessages({
                AnteriorPass: messages.AnteriorPass,
                NuevoPass: '',
                ConfirmarPass: ''
            })
            return
        }
        setError("ConfirmarPass", false)
        setMessage("ConfirmarPass", '')
    }

    const [showPassword1, setShowPassword1] = React.useState(false);
    const handleClickShowPassword1 = () => setShowPassword1((show) => !show);
    const handleMouseDownPassword1 = (event) => {
        event.preventDefault();
    };

    const [showPassword2, setShowPassword2] = React.useState(false);
    const handleClickShowPassword2 = () => setShowPassword2((show) => !show);
    const handleMouseDownPassword2 = (event) => {
        event.preventDefault();
    };

    const [showPassword3, setShowPassword3] = React.useState(false);
    const handleClickShowPassword3 = () => setShowPassword3((show) => !show);
    const handleMouseDownPassword3 = (event) => {
        event.preventDefault();
    };


    return (
        <div>
            <Grid container spacing={3} mb={2}>
                <Grid item xs>
                    <h2 style={{ fontSize: 14 }}>
                        <strong>Cambio de contraseña</strong>
                    </h2>
                </Grid>
                <Grid item xs>
                    <div style={{ position: "relative" }}>
                        <IconButton
                            aria-label="close"
                            onClick={onClose}
                            style={{
                                position: "absolute",
                                top: "-10px",
                                right: 8,
                                color: (theme) => theme.palette.grey[500],
                            }}
                        >
                            <CloseIcon />
                        </IconButton>
                    </div>
                </Grid>
            </Grid>
            <DialogContent>
                <Box
                    noValidate
                    component="form"
                    sx={{
                        display: 'flex',
                        flexDirection: 'column',
                        m: 'auto',
                        width: '100 ',
                    }}
                >
                    <TextField
                        size="small"
                        type={showPassword1 ? 'text' : 'password'}
                        margin="normal"
                        required
                        fullWidth
                        id="anteriorPass"
                        label="Contraseña anterior"
                        name="anteriorPass"
                        autoComplete='off'
                        error={errors.AnteriorPass}
                        onChange={(e) => {
                            setValue("AnteriorPass", e.target.value);
                            setError("AnteriorPass", (e.target.value.length < 1));
                            setMessage("AnteriorPass",
                                (e.target.value.length < 1) ? ErrorMessages.usuario.ContraseñaRequerida : ""
                            );
                        }}
                        helperText={messages.AnteriorPass}
                        value={model.AnteriorPass || ""}
                        onPaste={(e) => {
                            e.preventDefault()
                            return false;
                        }}
                        onCopy={(e) => {
                            e.preventDefault()
                            return false;
                        }}
                        InputProps={{
                            endAdornment: (
                                <InputAdornment position="end">
                                    <IconButton
                                        aria-label="toggle password visibility"
                                        onClick={handleClickShowPassword1}
                                        onMouseDown={handleMouseDownPassword1}
                                        edge="end"
                                    >
                                        {showPassword1 ? <VisibilityOff /> : <Visibility />}
                                    </IconButton>
                                </InputAdornment>
                            )
                        }}
                    />
                    <TextField
                        size="small"
                        type={showPassword2 ? 'text' : 'password'}
                        margin="normal"
                        required
                        fullWidth
                        id="newPass"
                        label="Nueva contraseña"
                        name="newPass"
                        autoComplete='off'
                        error={errors.NuevoPass}
                        onChange={(e) => {
                            setValue("NuevoPass", e.target.value)
                            validarNuevoPass(e.target.value)
                        }}
                        helperText={messages.NuevoPass}
                        value={model.NuevoPass || ""}
                        onPaste={(e) => {
                            e.preventDefault()
                            return false;
                        }}
                        onCopy={(e) => {
                            e.preventDefault()
                            return false;
                        }}
                        InputProps={{
                            endAdornment: (
                                <InputAdornment position="end">
                                    <IconButton
                                        aria-label="toggle password visibility"
                                        onClick={handleClickShowPassword2}
                                        onMouseDown={handleMouseDownPassword2}
                                        edge="end"
                                    >
                                        {showPassword2 ? <VisibilityOff /> : <Visibility />}
                                    </IconButton>
                                </InputAdornment>
                            )
                        }}
                    />
                    <TextField
                        size="small"
                        type={showPassword3 ? 'text' : 'password'}
                        margin="normal"
                        required
                        fullWidth
                        id="ConfirmarPass"
                        label="Confirmar contraseña"
                        name="ConfirmarPass"
                        autoComplete='off'
                        error={errors.ConfirmarPass}
                        onChange={(e) => {
                            setValue("ConfirmarPass", e.target.value);
                            validarConfirmarPass(e.target.value)
                        }}
                        helperText={messages.ConfirmarPass}
                        value={model.ConfirmarPass || ""}
                        onPaste={(e) => {
                            e.preventDefault()
                            return false;
                        }}
                        onCopy={(e) => {
                            e.preventDefault()
                            return false;
                        }}
                        InputProps={{
                            endAdornment: (
                                <InputAdornment position="end">
                                    <IconButton
                                        aria-label="toggle password visibility"
                                        onClick={handleClickShowPassword3}
                                        onMouseDown={handleMouseDownPassword3}
                                        edge="end"
                                    >
                                        {showPassword3 ? <VisibilityOff /> : <Visibility />}
                                    </IconButton>
                                </InputAdornment>
                            )
                        }}
                    />
                </Box>
            </DialogContent>
            <DialogActions variant="paddi">
                <Button
                    variant="contained"
                    onClick={updatePasswordUser}
                    disabled={disabledAceptar}>
                    Guardar
                </Button>
            </DialogActions>
        </div>
    );
}

export default observer(ModalChangePass);